import * as React from "react";
import { Button, Space, Tooltip } from "antd";
import { CardContent } from "../../../components/antd/card/CardContent";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import { formSetValue, useCpFormValue } from "../../gvc/testNewForm/utils";
import { useCpFormContext } from "../../../components/form/useCpFormContext";
import { CpInput } from "../../gvc/testNewForm/CpInput";
import { CpLabel } from "../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../gvc/testNewForm/CpFormItem";
import { CpErrorWarning } from "../../gvc/testNewForm/CpErrorWarning";

interface Props {}
export const SecretDataNatsAccount: React.FC<Props> = ({}) => {
  const { id } = useCpFormContext();
  const isPrivateKeyVisible = useCpFormValue(`natsAccount.privateKey.isVisible`);

  return (
    <>
      <CardContent>
        <CpFormItem>
          <CpLabel name={`natsAccount.accountId`}>Account ID</CpLabel>
          <CpInput name={`natsAccount.accountId`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`natsAccount.accountId`} />
        </CpFormItem>
        <CpFormItem>
          <CpLabel name={`natsAccount.privateKey.value`}>Private Key</CpLabel>
          <Space.Compact>
            <CpInput
              name={`natsAccount.privateKey.value`}
              type={isPrivateKeyVisible ? "text" : `password`}
              style={{ maxWidth: 600 }}
            />
            <Tooltip title={isPrivateKeyVisible ? "Hide" : "Show"}>
              <Button
                icon={isPrivateKeyVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                onClick={() => formSetValue(id, `natsAccount.privateKey.isVisible`, !isPrivateKeyVisible)}
              />
            </Tooltip>
          </Space.Compact>
          <CpErrorWarning name={`natsAccount.privateKey.value`} />
        </CpFormItem>
      </CardContent>
    </>
  );
};
